<script setup>
import { showModal, hideModal } from '@/Utils/modalBus'
import { computed, ref, onMounted, watch, getCurrentInstance } from 'vue'
import { useNotification } from "@kyvg/vue3-notification"
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import PlaylistService from "@/services/Playlistservice"
import IconBase from '@/components/icon/IconBase.vue'
import IconBin from '@/components/icon/IconBin.vue'
import BackButton from '@/components/Atoms/BackButton.vue'
import FormButton from '../Atoms/FormButton.vue'
import Title from '../ui/Title.vue'
import Alert from '../Atoms/Alert.vue'
import Badge from '../Badge.vue'
import HeaderHelperLinks from '@/components/Moleculas/HeaderHelperLinks.vue'

const { notify } = useNotification()
const instance = getCurrentInstance()
const root = instance.proxy.$root
const route = useRoute()
const store = useStore()

// Computed
const hasLiveSubscription = computed(() => store.getters['User/hasLiveSubscription'])
const isLiveSubscriptionExpired = computed(() => store.getters['User/isLiveSubscriptionExpired'])

const playlists = computed(() => store.getters['Playlist/playlist'])
const currentPlaylist = computed(() => store.getters['Playlist/currentPlaylist'])

// Methods
const onPlaylistNameChange = async (newName) => {
  if (newName === currentPlaylist.value.name) return
  const isNameAlredyExist = playlists.value.find(playlist => playlist.name === newName)
  if (isNameAlredyExist) {
    console.log('case')
    notify({ group: 'error', text: `A playlist named "${newName}" already exists.` })
    return
  } else {
    await PlaylistService.nameChange(currentPlaylist.value._id, newName)
    await store.dispatch('Playlist/getPlaylist', true)
  }
}

const playlistToggle = async () => {
  const newState = currentPlaylist.value.disabled === true ? false : true
  await PlaylistService.playlistToggle(currentPlaylist.value._id, newState)
  await store.dispatch('Playlist/getPlaylist', true)
  notify({ group: 'success', text: `Your playlist is ${newState ? 'Disabled' : 'Enabled'}` })
}

const removePlaylist = () => showModal('delete-playlist')
</script>
<template>
  <header class="lg:mt-10">
    <div class="flex gap-2 !flex-wrap lg:!flex-nowrap items-center">
      <div class="flex gap-2 items-center min-w-0 basis-full lg:basis-fit">
        <BackButton to="/playlists" />
        <Title :editable="true" :title="currentPlaylist?.name" @changed="onPlaylistNameChange"
          titleClasses="text-lg font-medium rounded-md block" />
        <Badge class="shrink-0 truncate" pill :type="currentPlaylist?.disabled ? 'main' : 'enabled'"
          :title="currentPlaylist?.disabled ? 'Disabled' : '• Enabled'" />
      </div>
      <HeaderHelperLinks class="w-full lg:mr-2 lg:w-auto lg:basis-auto"
        howItWorksLink="https://docs.castr.com/en/articles/8181381-create-playlist-for-your-content"
        howItWorksText="How playlists work" tutorialLink="tDgMUJ40LkS3jrnJeMTQc" />
      <FormButton class="flex-1 justify-center sm:flex-none sm:ml-auto lg:ml-0 shrink-0" @click="playlistToggle" :type="currentPlaylist?.disabled ? 'main' : 'secondary'">
        {{ currentPlaylist?.disabled ? 'Enable' : 'Disable' }}
      </FormButton>
      <FormButton class="shrink-0" @click="removePlaylist" isIcon type="danger">
        <icon-base>
          <IconBin />
        </icon-base>
      </FormButton>
    </div>
    <div class="col-span-8">
      <Alert type="error" v-if="!hasLiveSubscription || isLiveSubscriptionExpired">
        Your plan has ended. Please <a class="underline" target="_blank" href="/app/subscribe">upgrade</a> to continue.
      </Alert>
    </div>
  </header>
</template>